<div class="home">
  <!-- Hero Section -->
  <section class="hero">
    <div class="container">
      <div class="hero-content">
        <h1 class="hero-title">
          Benvenuto su AI PodLab
        </h1>
        <p class="hero-subtitle">
          Il podcast che esplora scienza, tecnologia e innovazione
        </p>
        <div class="hero-actions">
          <a routerLink="/episodi" class="btn btn-primary">
            Esplora gli Episodi
          </a>
          <a routerLink="/about" class="btn btn-outline">
            Scopri di più
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- Latest Episodes Section -->
  <section class="latest-episodes">
    <div class="container">
      <div class="section-header">
        <h2>Ultimi Episodi</h2>
        <a routerLink="/episodi" class="view-all">
          Vedi tutti →
        </a>
      </div>

      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading">
        <div class="loading-spinner"></div>
      </div>

      <!-- Error State -->
      <div *ngIf="error && !isLoading" class="error-message">
        <p>{{ error }}</p>
        <button class="btn btn-primary" (click)="loadLatestEpisodes()">
          Riprova
        </button>
      </div>

      <!-- Episodes Grid -->
      <div *ngIf="!isLoading && !error" class="episodes-grid">
        <div *ngFor="let episode of latestEpisodes; let i = index" class="episode-card">
          <!-- Cover Image con link -->
          <a [routerLink]="['/episodi', episode.slug]" class="episode-cover-link">
            <div class="episode-cover">
              <img 
                [src]="getCoverImageUrl(episode.coverImage, 'medium')" 
                [alt]="episode.title"
                class="cover-image"
                [attr.fetchpriority]="i === 0 ? 'high' : null"
                [attr.loading]="i === 0 ? 'eager' : 'lazy'"
              />
              <div class="play-overlay">
                <div class="play-button">▶</div>
              </div>
            </div>
          </a>

          <!-- Episode Info -->
          <div class="episode-info">
            <div class="episode-meta">
              <a 
                *ngIf="episode.categorySlug" 
                [routerLink]="['/categoria', episode.categorySlug]"
                class="category"
                (click)="$event.stopPropagation()"
              >
                {{ episode.categoryName }}
              </a>
              <span *ngIf="!episode.categorySlug" class="category">
                {{ episode.categoryName }}
              </span>
              <span class="duration">{{ formatDuration(episode.duration) }}</span>
            </div>
            
            <a [routerLink]="['/episodi', episode.slug]" class="episode-title-link">
              <h3 class="episode-title">{{ episode.title }}</h3>
            </a>
            
            <p class="episode-description">
              {{ episode.description }}
            </p>

            <div class="episode-footer">
              <span class="date">{{ formatDate(episode.publishedAt) }}</span>
              <div class="tags">
                <ng-container *ngFor="let tag of (episode.tagNames || []).slice(0, 3); let i = index">
                  <a 
                    *ngIf="episode.tagSlugs && episode.tagSlugs[i]"
                    [routerLink]="['/tag', episode.tagSlugs[i]]"
                    class="tag tag-clickable"
                    (click)="$event.stopPropagation()"
                  >
                    #{{ tag }}
                  </a>
                  <span 
                    *ngIf="!episode.tagSlugs || !episode.tagSlugs[i]"
                    class="tag"
                  >
                    #{{ tag }}
                  </span>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="!isLoading && !error && latestEpisodes.length === 0" class="empty-state">
        <p>Nessun episodio disponibile al momento.</p>
      </div>
    </div>
  </section>

  <!-- Features Section -->
  <section class="features">
    <div class="container">
      <h2 class="text-center mb-4">Perché ascoltare PodLab?</h2>
      
      <div class="features-grid">
        <div class="feature-card">
          <div class="feature-icon">🔬</div>
          <h3>Contenuti Scientifici</h3>
          <p>Approfondimenti su scienza e ricerca dalle menti più brillanti</p>
        </div>

        <div class="feature-card">
          <div class="feature-icon">💻</div>
          <h3>Tecnologia</h3>
          <p>Le ultime novità dal mondo tech e dell'innovazione</p>
        </div>

        <div class="feature-card">
          <div class="feature-icon">🎯</div>
          <h3>Sempre Aggiornato</h3>
          <p>Nuovi episodi ogni settimana con contenuti freschi</p>
        </div>
      </div>
    </div>
  </section>

  <!-- CTA Section -->
  <section class="cta">
    <div class="container">
      <div class="cta-content">
        <h2>Non perdere nessun episodio</h2>
        <p>Iscriviti al nostro feed RSS per ricevere tutti i nuovi episodi</p>
        <div class="cta-actions">
          <a [href]="rssUrl" target="_blank" class="btn btn-primary">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" style="margin-right: 8px;">
              <path d="M6.503 20.752c0 1.794-1.456 3.248-3.251 3.248-1.796 0-3.252-1.454-3.252-3.248 0-1.794 1.456-3.248 3.252-3.248 1.795.001 3.251 1.454 3.251 3.248zm-6.503-12.572v4.811c6.05.062 10.96 4.966 11.022 11.009h4.817c-.062-8.71-7.118-15.758-15.839-15.82zm0-3.368c10.58.046 19.152 8.594 19.183 19.188h4.817c-.03-13.231-10.755-23.954-24-24v4.812z"/>
            </svg>
            Iscriviti al Feed RSS
          </a>
        </div>
      </div>
    </div>
  </section>
</div>
